import * as $runtime from "../runtime.js";
import * as Control$dMonad$dExcept$dTrans from "../Control.Monad.Except.Trans/index.js";
import * as Data$dGeneric$dRep from "../Data.Generic.Rep/index.js";
import * as Data$dIdentity from "../Data.Identity/index.js";
import * as Data$dList$dTypes from "../Data.List.Types/index.js";
import * as Data$dNonEmpty from "../Data.NonEmpty/index.js";
import * as Data$dShow from "../Data.Show/index.js";
import * as Data$dShow$dGeneric from "../Data.Show.Generic/index.js";
import * as Foreign from "../Foreign/index.js";
import * as Restaumatic$dI18n from "../Restaumatic.I18n/index.js";
import * as Restaumatic$dI18n$dTranslationKeys from "../Restaumatic.I18n.TranslationKeys/index.js";
import * as Restaumatic$dOrders$dTypes$dFulfillmentMethodType from "../Restaumatic.Orders.Types.FulfillmentMethodType/index.js";
import * as Restaumatic$dSite$dTranslations$dKeys from "../Restaumatic.Site.Translations.Keys/index.js";
import * as Type$dProxy from "../Type.Proxy/index.js";
const $DeliveryMethod$p = (tag, _1) => ({tag, _1});
const $Email = (tag, _1) => ({tag, _1});
const genericShowSum = /* #__PURE__ */ (() => {
  const $0 = Data$dShow$dGeneric.genericShowConstructor(Data$dShow$dGeneric.genericShowArgsNoArguments)({reflectSymbol: () => "DeliveryMethodPickup"});
  return dictGenericShow1 => (
    {
      "genericShow'": v => {
        if (v.tag === "Inl") { return $0["genericShow'"](v._1); }
        if (v.tag === "Inr") { return dictGenericShow1["genericShow'"](v._1); }
        $runtime.fail();
      }
    }
  );
})();
const DeliveryMethodShipmentIsSymbol = {reflectSymbol: () => "DeliveryMethodShipment"};
const DeliveryMethodDineInIsSymbol = {reflectSymbol: () => "DeliveryMethodDineIn"};
const DeliveryMethodNoContactDeliveryIsSymbol = {reflectSymbol: () => "DeliveryMethodNoContactDelivery"};
const bind = /* #__PURE__ */ (() => Control$dMonad$dExcept$dTrans.bindExceptT(Data$dIdentity.monadIdentity).bind)();
const readString = /* #__PURE__ */ Foreign.unsafeReadTagged(Data$dIdentity.monadIdentity)("String");
const pure = /* #__PURE__ */ (() => Control$dMonad$dExcept$dTrans.applicativeExceptT(Data$dIdentity.monadIdentity).pure)();
const fail = /* #__PURE__ */ (() => {
  const $0 = Control$dMonad$dExcept$dTrans.monadThrowExceptT(Data$dIdentity.monadIdentity).throwError;
  return x => $0(Data$dNonEmpty.$NonEmpty(x, Data$dList$dTypes.Nil));
})();
const Phone = x => x;
const Email = value0 => $Email("Email", value0);
const NoEmail = /* #__PURE__ */ $Email("NoEmail");
const DeliveryMethodPickup = /* #__PURE__ */ $DeliveryMethod$p("DeliveryMethodPickup");
const DeliveryMethodShipment = value0 => $DeliveryMethod$p("DeliveryMethodShipment", value0);
const DeliveryMethodDineIn = value0 => $DeliveryMethod$p("DeliveryMethodDineIn", value0);
const DeliveryMethodNoContactDelivery = value0 => $DeliveryMethod$p("DeliveryMethodNoContactDelivery", value0);
const showPhone = Data$dShow.showString;
const newtypePhone_ = {Coercible0: () => {}};
const genericEmail_ = {
  to: x => {
    if (x.tag === "Inl") { return $Email("Email", x._1); }
    if (x.tag === "Inr") { return NoEmail; }
    $runtime.fail();
  },
  from: x => {
    if (x.tag === "Email") { return Data$dGeneric$dRep.$Sum("Inl", x._1); }
    if (x.tag === "NoEmail") { return Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.NoArguments); }
    $runtime.fail();
  }
};
const showEmail = {
  show: /* #__PURE__ */ (() => {
    const $0 = Data$dShow$dGeneric.genericShowConstructor({genericShowArgs: v => [Data$dShow.showStringImpl(v)]})({reflectSymbol: () => "Email"});
    const $1 = Data$dShow$dGeneric.genericShowConstructor(Data$dShow$dGeneric.genericShowArgsNoArguments)({reflectSymbol: () => "NoEmail"});
    return x => {
      if (x.tag === "Email") { return $0["genericShow'"](x._1); }
      if (x.tag === "NoEmail") { return $1["genericShow'"](Data$dGeneric$dRep.NoArguments); }
      $runtime.fail();
    };
  })()
};
const toFulfillmentMethodType = deliveryMethod => {
  if (deliveryMethod.tag === "DeliveryMethodPickup") { return Restaumatic$dOrders$dTypes$dFulfillmentMethodType.Takeaway; }
  if (deliveryMethod.tag === "DeliveryMethodShipment") { return Restaumatic$dOrders$dTypes$dFulfillmentMethodType.Delivery; }
  if (deliveryMethod.tag === "DeliveryMethodDineIn") { return Restaumatic$dOrders$dTypes$dFulfillmentMethodType.DineIn; }
  if (deliveryMethod.tag === "DeliveryMethodNoContactDelivery") { return Restaumatic$dOrders$dTypes$dFulfillmentMethodType.NoContactDelivery; }
  $runtime.fail();
};
const sequenceDeliveryMethod = dictApplicative => {
  const map = dictApplicative.Apply0().Functor0().map;
  return v => {
    if (v.tag === "DeliveryMethodPickup") { return dictApplicative.pure(DeliveryMethodPickup); }
    if (v.tag === "DeliveryMethodShipment") { return map(x => $DeliveryMethod$p("DeliveryMethodShipment", x))(v._1); }
    if (v.tag === "DeliveryMethodDineIn") { return map(x => $DeliveryMethod$p("DeliveryMethodDineIn", x))(v._1); }
    if (v.tag === "DeliveryMethodNoContactDelivery") { return map(x => $DeliveryMethod$p("DeliveryMethodNoContactDelivery", x))(v._1); }
    $runtime.fail();
  };
};
const paymentMethodDescription = v => {
  if (v.tag === "Cash") {
    return Restaumatic$dI18n._translate(Restaumatic$dI18n$dTranslationKeys.unTranslationKey(Restaumatic$dSite$dTranslations$dKeys.t.payment_method.cash.label), {});
  }
  if (v.tag === "Card") {
    return Restaumatic$dI18n._translate(Restaumatic$dI18n$dTranslationKeys.unTranslationKey(Restaumatic$dSite$dTranslations$dKeys.t.payment_method.card.label), {});
  }
  if (v.tag === "Online") {
    return Restaumatic$dI18n._translate(Restaumatic$dI18n$dTranslationKeys.unTranslationKey(Restaumatic$dSite$dTranslations$dKeys.t.payment_method.online.label), {});
  }
  if (v.tag === "Prepaid") { return ""; }
  if (v.tag === "Offline") {
    return Restaumatic$dI18n._translate(Restaumatic$dI18n$dTranslationKeys.unTranslationKey(Restaumatic$dSite$dTranslations$dKeys.t.payment_method.online.offline), {});
  }
  if (v.tag === "CashAndCard") {
    return Restaumatic$dI18n._translate(Restaumatic$dI18n$dTranslationKeys.unTranslationKey(Restaumatic$dSite$dTranslations$dKeys.t.payment_method.online.cashAndCard), {});
  }
  if (v.tag === "BankTransfer") {
    return Restaumatic$dI18n._translate(Restaumatic$dI18n$dTranslationKeys.unTranslationKey(Restaumatic$dSite$dTranslations$dKeys.t.payment_method.bank_transfer.label), {});
  }
  $runtime.fail();
};
const hoistDeliveryMethod = f => v => {
  if (v.tag === "DeliveryMethodPickup") { return DeliveryMethodPickup; }
  if (v.tag === "DeliveryMethodShipment") { return $DeliveryMethod$p("DeliveryMethodShipment", f(v._1)); }
  if (v.tag === "DeliveryMethodDineIn") { return $DeliveryMethod$p("DeliveryMethodDineIn", f(v._1)); }
  if (v.tag === "DeliveryMethodNoContactDelivery") { return $DeliveryMethod$p("DeliveryMethodNoContactDelivery", f(v._1)); }
  $runtime.fail();
};
const genericDeliveryMethod = {
  to: x => {
    if (x.tag === "Inl") { return DeliveryMethodPickup; }
    if (x.tag === "Inr") {
      if (x._1.tag === "Inl") { return $DeliveryMethod$p("DeliveryMethodShipment", x._1._1); }
      if (x._1.tag === "Inr") {
        if (x._1._1.tag === "Inl") { return $DeliveryMethod$p("DeliveryMethodDineIn", x._1._1._1); }
        if (x._1._1.tag === "Inr") { return $DeliveryMethod$p("DeliveryMethodNoContactDelivery", x._1._1._1); }
        $runtime.fail();
      }
      $runtime.fail();
    }
    $runtime.fail();
  },
  from: x => {
    if (x.tag === "DeliveryMethodPickup") { return Data$dGeneric$dRep.$Sum("Inl", Data$dGeneric$dRep.NoArguments); }
    if (x.tag === "DeliveryMethodShipment") { return Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inl", x._1)); }
    if (x.tag === "DeliveryMethodDineIn") { return Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inl", x._1))); }
    if (x.tag === "DeliveryMethodNoContactDelivery") { return Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", x._1))); }
    $runtime.fail();
  }
};
const genericShow = dictGenericShow => x => dictGenericShow["genericShow'"](genericDeliveryMethod.from(x));
const showDeliveryMethod = dictShow => {
  const genericShowConstructor1 = Data$dShow$dGeneric.genericShowConstructor({genericShowArgs: v => [dictShow.show(v)]});
  const $0 = genericShowConstructor1(DeliveryMethodShipmentIsSymbol);
  const genericShowConstructor2 = genericShowConstructor1(DeliveryMethodNoContactDeliveryIsSymbol);
  return dictShow1 => (
    {
      show: genericShow(genericShowSum((() => {
        const $1 = Data$dShow$dGeneric.genericShowConstructor({genericShowArgs: v => [dictShow1.show(v)]})(DeliveryMethodDineInIsSymbol);
        return {
          "genericShow'": v => {
            if (v.tag === "Inl") { return $0["genericShow'"](v._1); }
            if (v.tag === "Inr") {
              if (v._1.tag === "Inl") { return $1["genericShow'"](v._1._1); }
              if (v._1.tag === "Inr") { return genericShowConstructor2["genericShow'"](v._1._1); }
              $runtime.fail();
            }
            $runtime.fail();
          }
        };
      })()))
    }
  );
};
const eqDeliveryMethod = dictEq => dictEq1 => (
  {
    eq: x => y => {
      const $0 = genericDeliveryMethod.from(x);
      const $1 = genericDeliveryMethod.from(y);
      if ($0.tag === "Inl") { return $1.tag === "Inl"; }
      if ($0.tag === "Inr") {
        if ($1.tag === "Inr") {
          if ($0._1.tag === "Inl") {
            if ($1._1.tag === "Inl") { return dictEq.eq($0._1._1)($1._1._1); }
            return false;
          }
          if ($0._1.tag === "Inr") {
            if ($1._1.tag === "Inr") {
              if ($0._1._1.tag === "Inl") {
                if ($1._1._1.tag === "Inl") { return dictEq1.eq($0._1._1._1)($1._1._1._1); }
                return false;
              }
              if ($0._1._1.tag === "Inr") {
                if ($1._1._1.tag === "Inr") { return dictEq.eq($0._1._1._1)($1._1._1._1); }
                return false;
              }
              return false;
            }
            return false;
          }
          return false;
        }
        return false;
      }
      return false;
    }
  }
);
const encodeDeliveryMethodType = {
  encode: v => {
    if (v.tag === "DeliveryMethodPickup") { return "pickup"; }
    if (v.tag === "DeliveryMethodShipment") { return "shipment"; }
    if (v.tag === "DeliveryMethodDineIn") { return "dine_in"; }
    if (v.tag === "DeliveryMethodNoContactDelivery") { return "no_contact_delivery"; }
    $runtime.fail();
  }
};
const decodeDeliveryMethodType = {
  decode: f => bind(readString(f))(str => {
    if (str === "pickup") { return pure(DeliveryMethodPickup); }
    if (str === "shipment") { return pure($DeliveryMethod$p("DeliveryMethodShipment", Type$dProxy.Proxy)); }
    if (str === "dine_in") { return pure($DeliveryMethod$p("DeliveryMethodDineIn", Type$dProxy.Proxy)); }
    if (str === "no_contact_delivery") { return pure($DeliveryMethod$p("DeliveryMethodNoContactDelivery", Type$dProxy.Proxy)); }
    return fail(Foreign.$ForeignError("ForeignError", "Invalid DeliveryMethodType: " + Data$dShow.showStringImpl(str)));
  })
};
export {
  $DeliveryMethod$p,
  $Email,
  DeliveryMethodDineIn,
  DeliveryMethodDineInIsSymbol,
  DeliveryMethodNoContactDelivery,
  DeliveryMethodNoContactDeliveryIsSymbol,
  DeliveryMethodPickup,
  DeliveryMethodShipment,
  DeliveryMethodShipmentIsSymbol,
  Email,
  NoEmail,
  Phone,
  bind,
  decodeDeliveryMethodType,
  encodeDeliveryMethodType,
  eqDeliveryMethod,
  fail,
  genericDeliveryMethod,
  genericEmail_,
  genericShow,
  genericShowSum,
  hoistDeliveryMethod,
  newtypePhone_,
  paymentMethodDescription,
  pure,
  readString,
  sequenceDeliveryMethod,
  showDeliveryMethod,
  showEmail,
  showPhone,
  toFulfillmentMethodType
};
